import { administratorRoles } from "../../config/roles";
import { RemoveContactFromMarketingList } from "../../api/marketingListService";
import { isFailedResponse } from "../../api/request";
import { RelatedTableActions } from "../relatedTableActions.types";
import { AddMarketingListAction } from "./AddMarketingListAction";

function listName(row: Record<string, unknown>) {
  return String(row.listname ?? "this marketing list");
}

// Kept with the page, as contactFieldComponents is, and handed over by the contact
// record definition. The same roles the old contact form gave these to.
export const contactRelatedTableActions: Record<string, RelatedTableActions> = {
  listmember: {
    roles: administratorRoles,
    add: AddMarketingListAction,
    remove: {
      label: (row) => `Remove from ${listName(row)}`,
      confirmation: (row) => ({
        title: "Remove from marketing list",
        confirmText: "Remove",
        message: `Are you sure you want to remove this contact from ${listName(
          row
        )}?`,
      }),
      remove: async (globalDispatch, parentId, row) =>
        !isFailedResponse(
          await RemoveContactFromMarketingList(
            globalDispatch,
            row.listid,
            parentId
          )
        ),
    },
  },
};
